/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/location-tile/custom-elements';

import { defineCustomElement as defineOsdsLocationTile } from '@ovhcloud/ods-stencil/components/location-tile/custom-elements/osds-location-tile.js';


export const OsdsLocationTile = /*@__PURE__*/ defineContainer<JSX.OsdsLocationTile>('osds-location-tile', defineOsdsLocationTile, [
  'color',
  'disabled',
  'flex',
  'iso',
  'interactive',
  'checking',
  'checked',
  'size',
  'variant',
  'hasFocus'
]);

